import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makePaymentsReqConfig = () => ({
  endpoint: 'paya',
  type: 'get',
  slug: [
    'users',
    {
      type: 'payload',
      selector: ['userId'],
    },
    'organizations',
  ],
});

const requestOptions = makePaymentsReqConfig();

export const consts = createReqConsts('payment-methods', 'payments');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/payment-methods/requests/payments-req.js